import { computed, effect, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RoyaltyDto, RoyaltyRunSplit } from '@mzic/mzic-interfaces';
import { Subject } from 'rxjs';

interface RoyaltyRunState {
  loaded: boolean;
  royalty: RoyaltyDto | null;
  royaltyRunSplits: RoyaltyRunSplit[]; // Armazena os splits selecionados
}

@Injectable({
  providedIn: 'root',
})
export class RoyaltyRunStateService {
  state = signal<RoyaltyRunState>({
    loaded: false,
    royalty: null,
    royaltyRunSplits: [],
  });

  // Cuida da UI exibida
  step = signal<number>(1);

  // Seletores do state
  isLoading = computed(() => !this.state().loaded);
  totalSplitsSelected = computed(() => this.state().royaltyRunSplits.length);
  sumTotalSplitsSelected = computed(() => {
    return this.state().royaltyRunSplits.reduce(
      (acc, item) => acc + item.generatedAmount,
      0,
    );
  });
  isAllSplitsSelected = computed(() => {
    return (
      this.state().royalty?.royaltySplits.length === this.totalSplitsSelected()
    );
  });

  // Reducers
  loadRoyalty$ = new Subject<RoyaltyDto>();
  updateSplits$ = new Subject<RoyaltyRunSplit[]>();

  constructor() {
    effect(() => {
      console.log('split run:', this.state());
    });

    this.loadRoyalty$.pipe(takeUntilDestroyed()).subscribe((royalty) => {
      this.state.update((state) => ({ ...state, loaded: true, royalty }));
    });

    this.updateSplits$
      .pipe(takeUntilDestroyed())
      .subscribe((royaltyRunSplits) => {
        this.state.update((state) => ({
          ...state,
          royaltyRunSplits: royaltyRunSplits,
        }));
      });
  }
}
